import { render, staticRenderFns } from "./IconForwardArrow.vue?vue&type=template&id=32d26926&scoped=true"
import script from "./IconForwardArrow.vue?vue&type=script&lang=js"
export * from "./IconForwardArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d26926",
  null
  
)

export default component.exports